import { Component, OnInit } from '@angular/core';
import { ContentService, DcrKeyPipe, HrefResolverService } from '@blk/cwp-ng-framework';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';
import { DocumentService } from '@ddt-web/data-service';
import { StoreService } from '@ddt-web/store-service';
import { UrlService, UrlUtils } from '@ddt-web/url';
import * as get from 'lodash/get';
import * as head from 'lodash/head';
import * as isEmpty from 'lodash/isEmpty';
import * as last from 'lodash/last';
import * as split from 'lodash/split';
import { catchError, finalize, first } from 'rxjs/operators';

import { ModelsBrowseStoreConfig } from '../config';
import { ModelFamilyDocument } from '../models';
import { ModelsBrowseDataService } from '../services/models-browse-data.service';

@Component({
	selector: 'mb-family-additional-resources',
	templateUrl: './family-additional-resources.component.html',
	styleUrls: ['./family-additional-resources.component.scss']
})
export class FamilyAdditionalResourcesComponent implements OnInit {

	@InjectConfig(ModelsExperienceConfigKey.SHOW_BRAND_AND_SHARE_LINK) private readonly showBrandAndShareLink: boolean = false;

	public documents: Array<string>;
	public modelFamilyDocuments: Array<ModelFamilyDocument>;
	public docIdAndLinkMap: Map<string, string>;
	public validDocArray = [];
	public isDataLoading: boolean = false;
	public isBlKModel: boolean = false;
	public factsSheetLink: string;
	public factsSheet: ModelFamilyDocument = <ModelFamilyDocument>{};
	public brandAndShareLink: string;
	private readonly isModelsRegroupingEnabled: boolean = true;
	constructor(
		private documentService: DocumentService,
		private contentService: ContentService,
		private urlService: UrlService,
		private storeService: StoreService,
		private modelsBrowseDataService: ModelsBrowseDataService,
		private hrefResolver: HrefResolverService
	) { }

	public ngOnInit(): void {
		const familyId = this.urlService.getModelFamilyId();

		this.modelsBrowseDataService.getAladdinTicker(familyId).pipe(first()).subscribe(aladdinTicker => {
			let factsSheetDcrKey;

			if (this.isModelsRegroupingEnabled) {
				factsSheetDcrKey = new DcrKeyPipe().transform(`${aladdinTicker}_FACTS_SHEET_HYPERLINK`);
			} else {
				factsSheetDcrKey = new DcrKeyPipe().transform(`${familyId}_FACTS_SHEET_HYPERLINK`);
			}
			this.factsSheetLink = this.contentService.get(factsSheetDcrKey, '');
		});

		this.storeService.selectById(ModelsBrowseStoreConfig.families, familyId).pipe(
			first(family => !!family)
		).subscribe(family => {
			this.documents = get(family, `${familyId}.documentIds`, []);
			this.isBlKModel = get(family, `${familyId}.subType`, '') === 'BLK';
			this.getDocuments();
		});
		if (this.showBrandAndShareLink) {
			const brandAndShareLink = this.hrefResolver.getResolvedUrl('brandAndShareToolUrl');
			this.brandAndShareLink = this.contentService.get('BRAND_SHARE_HYPERLINK', brandAndShareLink);
		}
	}

	public getDocuments(): void {
		const docIds = [];
		this.modelFamilyDocuments = this.documents.map(document => {
			// splitting the document string based on ':' delimiter
			const documentSplitArr = split(document, ':', 2);
			const docId = last(documentSplitArr);
			docIds.push(docId);
			return {
				materialType: head(documentSplitArr),
				docId: docId
			};
		});
		this.getDocumentLinks(docIds);
	}

	public getDocumentLinks(docIds: Array<string>): void {
		if (!isEmpty(docIds)) {
			this.documentService
				.getDocLink(docIds)
				.pipe(
					catchError(error => {
						this.isDataLoading = false;
						console.error('Error getting family documents!');
						throw error;
					}),
					finalize(() => this.addFactSheetToDocArray())
				)
				.subscribe(result => {
					this.isDataLoading = false;
					this.docIdAndLinkMap = result;
					this.enrichDocumentArray();
				});
		}
	}

	public enrichDocumentArray(): void {
		this.modelFamilyDocuments.forEach(docElem => {
			if (!docElem.materialType || !docElem.docId) {
				console.log(`Document Error: Missing data for document`);
			} else {
				const materialType = docElem.materialType.toUpperCase();
				docElem.label = this.contentService.get(materialType, materialType);
				docElem.link = this.docIdAndLinkMap.get(String(docElem.docId));
				docElem.iconType = 'download';
				if (docElem.link) {
					this.validDocArray.push(docElem);
				}
			}
		});
	}
	public addFactSheetToDocArray(): void {
		if (this.factsSheetLink) {
			this.factsSheet.label = this.contentService.get('VIEW_FACTS_SHEET_HYPERLINK', 'View All Fact Sheets');
			this.factsSheet.link = UrlUtils.htmlDecode(this.factsSheetLink);
			this.factsSheet.iconType = 'external-link-alt';
			this.validDocArray.push(this.factsSheet);
		}
	}
}

